import { Component, OnInit } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { WidgetService } from '../../services/widget.service';

class CategoryResult {
  score: number;
  grade: string;
  points: Array<string>;
  videoURL: string;
}

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss']
})
export class ResultsComponent implements OnInit {
  activeCat = '';
  categoryData = {};
  categoryList = [];
  nextCat = '';
  isAssesmentCompleted = false;
  resultCat = '';
  result: CategoryResult = new CategoryResult();



  constructor(
    private stateService: AppStateService,
    private router: Router,
    private route: ActivatedRoute,
    private service: WidgetService,
  ) {

  }

  ngOnInit(): void {
    this.activeCat = this.route.snapshot.paramMap.get('slug');
    this.stateService.getCategoriesData().subscribe(val => {
      this.categoryData = val;
      this.getResult();
    });
    this.stateService.getCategoryList().subscribe(list => {
      this.categoryList = list;
      this.stateService.setActiveCategory(this.activeCat);
      if (this.categoryList.indexOf(this.activeCat) < this.categoryList.length - 1) {
        this.nextCat = this.categoryList[this.categoryList.indexOf(this.activeCat) + 1];
        this.isAssesmentCompleted = false;
      } else {
        this.isAssesmentCompleted = true;
      }

    });

  }

  getResult() {
    this.service.getCategoryResult({ id: localStorage.getItem(this.activeCat), name: this.categoryData[this.activeCat]?.name }).subscribe(res => {
      if (res && res.data) {
        this.result = res.data;
        this.stateService.setResult({
          score: res.data.score
        })
      }
    }, err => {
      console.log(err);
    })
  }

  onClickFinish() {
    this.router.navigate(['schedule-call']);
  }



  onClickNext() {
    if (this.isAssesmentCompleted) {

    } else {
      this.stateService.setActiveCategory(this.nextCat);
      this.router.navigate([`pages/quiz/${this.nextCat}`]);
    }
  }

}
